import React, { useState } from 'react';
import SectionHeading from '../UI/SectionHeading';
import Button from '../UI/Button';
import Input from '../UI/Input';
import './ContactSection.css';

interface FormData {
  name: string;
  company: string;
  email: string;
  phone: string;
  message: string;
}

const ContactSection: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [formSuccess, setFormSuccess] = useState<boolean>(false);
  const [formError, setFormError] = useState<string | null>(null);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError(null);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Reset form after successful submission
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      });
      
      setFormSuccess(true);
    } catch (error) {
      setFormError('Произошла ошибка при отправке формы. Пожалуйста, попробуйте снова.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section section">
      <div className="container">
        <SectionHeading 
          title="Заявка на сотрудничество"
          subtitle="Оставьте свои контактные данные, и мы свяжемся с вами в ближайшее время"
        />
        
        <div className="contact-form">
          {formSuccess ? (
            <div className="form-success">
              <h3>Спасибо за ваше обращение!</h3>
              <p>Мы свяжемся с вами в ближайшее время.</p>
              <Button 
  variant="secondary" 
  onClick={() => setFormSuccess(false)}
>
  Отправить еще одну заявку
</Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-col">
                  <Input
                    label="Имя"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Введите ваше имя"
                    required
                  />
                </div>
                <div className="form-col">
                  <Input
                    label="Компания"
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Название вашей компании"
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-col">
                  <Input
                    label="Email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Ваш email адрес"
                    required
                  />
                </div>
                <div className="form-col">
                  <Input
                    label="Телефон"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Ваш номер телефона"
                    required
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="form-label">Сообщение</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Расскажите о вашем проекте или задайте вопрос"
                  rows={5}
                ></textarea>
              </div>
              
              {formError && <div className="form-error">{formError}</div>}
              
              <Button 
  type="submit" 
  variant="gradient" // Changed from "primary" to "gradient"
  size="large" 
  disabled={isSubmitting}
>
  {isSubmitting ? 'Отправка...' : 'Отправить заявку'}
</Button>
            </form>
          )}
        </div>
      </div>

    </section>
  );
};

export default ContactSection;